<template>
  <div class="goods-series">
    <div class="brand-list">
      <div
        v-if="goodsList.imgurl.length > 5"
        class="swiper-series-button-prev swiper-button-prev swiper-button-white"
      ></div>
      <div class="swiper-container-series">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(goods, index) in goodsList.imgurl"
            @click="goto(goodsList['name'][index])"
          >
            <div class="img-box">
              <div class="img-box-item">
                <img :src="goods" />
              </div>
            </div>
            <p>{{ goodsList["name"][index] }}</p>
          </div>
        </div>
      </div>
      <div
        v-if="goodsList.imgurl.length > 5"
        class="swiper-series-button-next swiper-button-next swiper-button-white"
      ></div>
    </div>
  </div>
</template>
<script>
//引用swiper
import Swiper from "swiper";
//引用swiper样式
import "swiper/swiper.min.css";
export default {
  props: {
    goodsList: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      bannerList: [
        {
          title: "RV减速机",
          imgUlr: "https://image.sjyuan.net.cn/img/mvb/mEj3Ap7xYX.png",
        },
        {
          title: "并联机器人",
          imgUlr: "https://image.sjyuan.net.cn/img/mvb/mEj3Ap7xYX.png",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(function () {
      this.getSwiper();
    });
  },
  watch: {},
  methods: {
    getSwiper() {
      this.gallery = new Swiper(".swiper-container-series", {
        spaceBetween: 0,
        slidesPerView: 5,
        navigation: {
          nextEl: ".swiper-series-button-next",
          prevEl: ".swiper-series-button-prev",
        },
      });
    },
    goto(val) {
      this.$api.goods.getSearch(val, "", 1).then((res) => {
        if (res.data.datas.data.length > 0) {
          var index = res.data.datas.data.findIndex((item) => {
            if (item.model == val) {
              return true;
            }
          });
          if (index == -1) {
            index = 0;
          }

          this.$router.push({
            name: "goodsinfo",
            params: { goodsid: res.data.datas.data[index].id },
          });
        }
      });
    },
  },
};
</script>

<style  scoped>
.swiper-slide {
  text-align: center;
  cursor: pointer;
}
.swiper-slide img:hover {
  transform: translateX(0) scale(1.1);
}
.img-box {
  padding: 10px 10px;
}
.img-box .img-box-item {
  padding: 10px 10px;
}
.img-box-item:hover {
  box-shadow: 0 0 6px rgba(38, 85, 174, 0.3);
}
.swiper-slide p {
  margin-top: 20px;
  font-size: 20px;
  color: #666;
}
.swiper-slide img {
  width: 80%;
  margin: 0 auto;
}
.swiper-wrapper {
  padding: 10px 0;
}
/* .swiper-slide img{
        width: 100%;
    } */
.goods-series {
  overflow: hidden;
  /* margin-bottom: 50px; */
}
.brand-list {
  width: 100%;
  position: relative;
  height: 250px;
}
.swiper-container-series {
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  color: #d8dadb;
}
</style>


// WEBPACK FOOTER //
// src/components/goods/GoodsSeriesSwiper.vue